import { useSelector, useContext } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { io } from 'socket.io-client';
// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { createContext, useEffect, useState } from 'react';
import ApiCall from 'services/axiosConfig';

// ==============================|| APP ||============================== //

// const socket = io('')

export const AuthContext = createContext();

const App = () => {
  const customization = useSelector((state) => state.customization);

  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [notification, setNotification] = useState([]);

  const logout = () => {
    // Remove user information and set authentication status to false
    setUser(null);
    setIsAuthenticated(false);
  };

  const login = (userData) => {
    // Authenticate user and set user information and authentication status
    // console.log('login', userData);
    setUser(userData);
    setIsAuthenticated(true);
  };

  const Authenticated = async () => {
    try {
      const AuthenticatedData = await ApiCall.SECURE_API.get(
        '/user/isAuthenticated'
      );
      const { data } = AuthenticatedData;
      if (data) {
        console.log('response', data);
        const { success, message, user } = data;
        if (success) {
          login(user);
        } else {
          // toast.error(message);
          window.location.href = '/login';
        }
      }
    } catch (err) {
      console.error(err);
      if (err.code == 'ERR_NETWORK') {
        toast.error(err.message);
      } else if (err.response.status) {
        toast.error(err.response.data.message);
      }
    }
  };

  useEffect(() => {
    let socket;
    if (user && isAuthenticated) {
      socket = io(process.env.REACT_APP_PUBLIC_SOCKET_URL, {
        query: {
          userId: user._id,
        },
      });
      console.log('socket........', socket);
      socket.on(
        'connect',
        () => {
          socket.emit('message', 'hello notification');
          // socket.emit('join_department', user.department);
          socket.on('message', (data) => {
            console.log('notification', data);
          });
          socket.on('send_notification', (data) => {
            console.log('notification', data);
            setNotification([] || data);
          });
        },
        []
      );
    } else {
      console.log('Authenticated');
      Authenticated();
    }
    return () => {
      socket?.disconnect();
    };
  }, [user]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <AuthContext.Provider
          value={{
            user,
            setUser,
            isAuthenticated,
            setIsAuthenticated,
            notification,
            setNotification,
            login,
            logout,
          }}
        >
          <CssBaseline />
          <NavigationScroll>
            <ToastContainer />
            <Routes />
          </NavigationScroll>
        </AuthContext.Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
